import store from '../store';
import lib from './lib';

const rules = {
	required: (value) => !!value || lib.translate('Это поле необходимо заполнить!')
};

export default rules;
